/**
 * @author       calvin@zumper.com (Calvin Yau)
 * @copyright    Copyright (c) 2018, Zumper
 * @description  NearbyHoods reducer
 */

import { combineReducers } from 'redux'
import { combineActions, handleAction, handleActions } from 'redux-actions'
import {
  BEGIN_LOADING_NEARBY_HOODS,
  ERROR_LOADING_NEARBY_HOODS,
  RECEIVE_NEARBY_HOODS,
} from '../constants'

const nearbyHoodsReducer = combineReducers({
  loading: handleActions(
    {
      [BEGIN_LOADING_NEARBY_HOODS]: () => true,
      [combineActions(ERROR_LOADING_NEARBY_HOODS, RECEIVE_NEARBY_HOODS)]: () => false,
    },
    false
  ),
  nearbyHoods: handleAction(
    RECEIVE_NEARBY_HOODS,
    (state, action) => {
      const { payload } = action
      if (payload) {
        const { nearbyHoods, selectedIds } = payload
        if (selectedIds) {
          const dict = new Map()
          return [
            ...nearbyHoods,
            ...state.filter(({ neighborhoodId }) => selectedIds.includes(neighborhoodId)),
          ].filter(({ neighborhoodId }) => {
            if (dict.has(neighborhoodId)) {
              return false
            }
            dict.set(neighborhoodId, true)
            return true
          })
        }
        return nearbyHoods
      }
      return state
    },
    []
  ),
})

export default nearbyHoodsReducer
